"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FeatureExpEnvironmentWithPaginationSchema = exports.FeatureExpEnvironmentTypeSchema = void 0;
const zod_1 = require("zod");
const schemas_1 = require("../schemas");
exports.FeatureExpEnvironmentTypeSchema = zod_1.z.object({
    id: zod_1.z.string(),
    is_main: zod_1.z.boolean(),
    environment: zod_1.z.string(),
    panic: zod_1.z.boolean(),
});
exports.FeatureExpEnvironmentWithPaginationSchema = schemas_1.FeatureExpPaginationSchema.extend({
    items: zod_1.z.array(exports.FeatureExpEnvironmentTypeSchema),
});
//# sourceMappingURL=schemas.js.map